import { allFaceCategories, FaceCategory } from "building-types/materials/faceCategories";
import type { FaceHashMap } from "building-types/materials/faceHashTypes";

export type BuildingEntityFaceHashMaps = {
  [K in keyof typeof FaceCategory]?: FaceHashMap; // Use the FaceCategory enum keys so they're suitable for serialization
};

export function faceDiffEntityMaskFromHashMaps(hashMaps: BuildingEntityFaceHashMaps): Set<FaceCategory> {
  return new Set(Object.keys(hashMaps).map((key) => FaceCategory[key]));
}

export const defaultFaceHashCategories: Set<FaceCategory> = new Set(
  allFaceCategories.filter(
    (c) =>
      c !== FaceCategory.GROUND &&
      c !== FaceCategory.PROP_FURNITURE &&
      c !== FaceCategory.ROOF_TOP_CUSTOMIZABLE_EXPORT_GEOMETRY &&
      c !== FaceCategory.ROOF_RIDGE_VENT &&
      c !== FaceCategory.ROOF_RIDGE_CAP &&
      c !== FaceCategory.WALL_FRAMING &&
      c !== FaceCategory.GABLE_END_WALL_FRAMING,
  ),
);
